"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var MobileRow_1 = __importDefault(require("./MobileRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useTableData_1 = require("./useTableData");
var useMobileData_1 = require("./useMobileData");
var ITEMS_PER_PAGE = 20;
var SportHistory = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _k = (0, react_1.useState)(false), mounted = _k[0], setMounted = _k[1];
    var _l = (0, react_1.useState)({ from: undefined, to: undefined }), dates = _l[0], setDates = _l[1];
    var _m = (0, swr_hooks_1.useBettingHistory)({
        count: ITEMS_PER_PAGE,
    }), bets = _m.data, loadMoreByFiler = _m.loadMoreByFiler, loadMore = _m.loadMore, isSubmitting = _m.isSubmitting;
    var searchPayload = (0, react_1.useMemo)(function () {
        var payload = {
            dateRange: {
                from: dates === null || dates === void 0 ? void 0 : dates.from,
                to: dates === null || dates === void 0 ? void 0 : dates.to,
            },
        };
        if (!(dates === null || dates === void 0 ? void 0 : dates.from)) {
            return {};
        }
        return payload;
    }, [dates === null || dates === void 0 ? void 0 : dates.from, dates === null || dates === void 0 ? void 0 : dates.to]);
    (0, react_1.useEffect)(function () {
        loadMoreByFiler(searchPayload);
    }, [searchPayload]);
    var loadMoreHandler = (0, react_1.useCallback)(function () {
        loadMore(searchPayload);
    }, [loadMore, searchPayload]);
    var bettingData = ((_c = (_b = (_a = bets === null || bets === void 0 ? void 0 : bets.data) === null || _a === void 0 ? void 0 : _a.betting) === null || _b === void 0 ? void 0 : _b.bets) === null || _c === void 0 ? void 0 : _c.edges) || [];
    var tableData = (0, useTableData_1.useTableData)(bettingData);
    var mobileData = (0, useMobileData_1.useMobileData)(bettingData);
    var onDateFilterChange = (0, react_1.useCallback)(function (dates) { return setDates(dates); }, []);
    (0, react_1.useEffect)(function () {
        setMounted(true);
    }, []);
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        Object.keys(breakpoints).length > 0 && !breakpoints.mobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersContainer }),
            react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates }))),
        Object.keys(breakpoints).length > 0 && breakpoints.mobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersContainerMobile },
                react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates })))),
        !bets && isSubmitting ? (react_1.default.createElement(ui_components_1.LoadingWithContainer, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            Object.keys(breakpoints).length > 0 &&
                !breakpoints.mobile &&
                !breakpoints.tablet && (react_1.default.createElement(ui_components_1.TableDataWithPagination, { data: tableData, totalCount: (_f = (_e = (_d = bets === null || bets === void 0 ? void 0 : bets.data) === null || _d === void 0 ? void 0 : _d.betting) === null || _e === void 0 ? void 0 : _e.bets) === null || _f === void 0 ? void 0 : _f.totalCount, loadMoreClick: loadMoreHandler, loading: isSubmitting })),
            Object.keys(breakpoints).length > 0 &&
                (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("br", null),
                react_1.default.createElement(ui_components_1.MobileDataTableWithPagination, { data: mobileData, rowComponent: MobileRow_1.default, totalCount: (_j = (_h = (_g = bets === null || bets === void 0 ? void 0 : bets.data) === null || _g === void 0 ? void 0 : _g.betting) === null || _h === void 0 ? void 0 : _h.bets) === null || _j === void 0 ? void 0 : _j.totalCount, loadMoreClick: loadMoreHandler, loading: isSubmitting })))))));
};
exports.default = SportHistory;
